import React, { Component } from 'react';
import Select from 'react-select';
import '../../Modal.css';
import { connect } from 'react-redux';
import { updateSelectedProvider } from '../../../../actions/adminActions/providersActions';
import { providers } from '../../../../apis/backend';

class EditModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: '',
      cities: [],
      name: ''
    };
  }

  clearState() {
    this.setState({
      id: '',
      cities: [],
      name: ''
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      prevProps.selectedProvider !== this.props.selectedProvider &&
      this.props.selectedProvider !== 0
    ) {
      const provider = this.props.providers.find((obj) => obj.id === this.props.selectedProvider);
      if (provider) {
        this.setState({
          cities: provider.cities.map((x) => ({ value: x.id, label: x.name })),
          name: provider.name
        });
      }
    }
  }

  async providerRequest() {
    try {
      await providers
        .patch(
          `/${this.props.selectedProvider}`,
          {
            cities: this.state.cities.map((city) => city.value),
            name: this.state.name
          },
          { headers: { authorization: this.props.employeeToken } }
        )
        .then(this.clearState())
        .catch((response) => {
          console.log(response);
          alert('Sorry, an error occurred. Please check your entries.');
        });
    } catch (err) {
      console.log('Request Failed.');
    }
  }

  render() {
    const cityOptions = this.props.cities.map((city) => {
      const option = {
        value: city.id,
        label: city.name
      };
      return option;
    });
    return (
      <div id="exampleModal" className="modal fade" style={{ overflow: 'scroll' }}>
        <div className="modal-dialog modal-dialog-centered lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Update Provider</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="input-group input-group-sm mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text" id="inputGroup-sizing-sm">
                    Provider Name
                  </span>
                </div>
                <input
                  type="text"
                  className="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  value={this.state.name}
                  onChange={(e) => this.setState({ name: e.target.value })}
                />
              </div>
              <div className="input-group input-group-sm mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text" id="inputGroup-sizing-sm">
                    Cities
                  </span>
                </div>
                <Select
                  name="ProviderCities"
                  id="ProviderCities"
                  className="multiselector"
                  isMulti
                  value={this.state.cities}
                  options={cityOptions}
                  onChange={(e) => {
                    this.setState({ cities: e });
                  }}
                />
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={() => this.clearState()}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-dark"
                data-dismiss="modal"
                onClick={() => {
                  this.providerRequest();
                }}
                disabled={!this.state.name != ''}
              >
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  providers: state.admin.admin.providers,
  cities: state.admin.admin.cities,
  selectedProvider: state.admin.providers.selectedProvider,
  employeeToken: state.auth.employeeToken
});

export default connect(mapStateToProps, { updateSelectedProvider })(EditModal);
